import { ProductionOrderDetailPage } from '@/features/production/pages/ProductionOrderDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/production/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["production.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductionOrderDetailPage,
})
